import React, { useState, useEffect, useRef } from 'react';
import { reqPoll, toErrorMessage } from './ServerUtils';
import { Alert, Box, Button, CircularProgress, MenuItem, Select, TextField } from '@mui/material';
import { NavBar } from './Navbar';

const DownloadDesign = ({generatedPng, generatedDesignId, error}) => {
    const [isTablet, setIsTablet] = useState(window.matchMedia('(max-width: 600px)').matches);  

  function download(url) {
    fetch(url + "&a=" + Math.random())
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'makemybrand-image.png';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      })
      .catch(error => console.error('Error downloading the image:', error));
  }
  

  let borderStuff = {
    border: "none",
    p: 2, 
    borderRadius: 2,
  }
  if (isTablet) {
    borderStuff = {}
  }

  return (
    <div>
      <NavBar />
      <Box sx={{
        backgroundColor: 'white', 
        margin: '30px auto', 
        width: "100%",
        overflow: "scroll",
        ...borderStuff
      }}>
        
          <div style={{
            textAlign: 'center',
            overflow: 'scroll',

            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            
            {generatedPng && (
              <div style={{ 

              }} > 
                <div>Your design is ready!</div>

                <div style={{
                  display: 'flex',
                  gap: 10,
                  justifyContent: 'center',
                  marginBottom: 10
                }}>
                  <Button variant="contained" sx={{ mt: 2 }} onClick={() => window.open('/design/' + generatedDesignId)} style={{
                    textTransform: "none"
                  }}>Edit</Button>
                  <Button variant="contained" sx={{ mt: 2 }} onClick={() => download(generatedPng)} style={{
                    textTransform: "none"
                  }}>Download</Button>
                </div>
                <div style={{ 
                  marginTop: 20,
                  border: '1px solid #ccc',
                }} > 
                  <img src={generatedPng} style={{ height: "100%"  }} /> 
                </div>
              </div>
            )}
            {error && 
            <Alert severity="error" sx={{ width: '100%', mt: 2 }}>
              {toErrorMessage(error)}
            </Alert>}

          </div>
       
      </Box>
      
    </div>
  );
};

export default DownloadDesign;
